import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import { logger } from '$utils'
import useStockStore from '../../store'
import { extractLineDataVariants } from './helper'

export default async function loader({ params }) {
  logger.debug(
    '[loader] About to await AppState being ready in EditInvoice loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in EditInvoice loader')

  const stockState = useStockStore.getState()
  const getInvoice = stockState.getInvoice(params.invoiceId)
  const getInitialInvoice = stockState.getInitialInvoice(params.invoiceId)
  const getSuppliers = stockState.getSuppliers()
  const getItems = stockState.getItems()
  const getBrands = stockState.getBrands()
  const getUnits = stockState.getUnits()
  const getSalesTax = stockState.getSalesTax()

  return defer({
    data: Promise.all([
      getInvoice,
      getInitialInvoice,
      getSuppliers,
      getItems,
      getBrands,
      getUnits,
      getSalesTax,
    ])
      .then(async (result) => {
        const items = result[3]
        const brands = result[4]
        const units = result[5]
        const salesTax = result[6]
        const purchaseOrderId =
          useStockStore.getState().invoice?.linkedPurchaseOrderId
        if (purchaseOrderId) {
          await stockState.getLinkedPurchaseOrder(purchaseOrderId)
        }
        stockState.setLineDataBySupplier(
          extractLineDataVariants(items, brands, units, salesTax)
        )
        return true
      })
      .catch((error) => {
        logger.error('Edit Invoices Promise.all error', error)
        return false
      }),
  })
}
